import React from "react";
import { Box, Container, Grid } from "@mui/material";
import VehicleTypeList from "../components/vehicles/VehicleTypeList";
import PageInfoTitle from "../../components/pageTitle/PageInfoTitle";
const ClientVehicleType = () => {
  return (
    <>
      <Grid
        container
        rowSpacing={1}
        columnSpacing={{ xs: 1, sm: 2, md: 12 }}
        sx={{ background: "#f4f4f4", paddingTop: "16px", height: "100vh" }}
      >
        <Grid
          item
          xs={12}
          md={3}
          sx={{ paddingLeft: "0px !important", paddingTop: "0px !important" }}
        >
          <Box
            sx={{
              bgcolor: "#fff",
              height: { xs: "auto", md: "100vh" },
              // border: "1px solid #d1cfcf",
              // borderRadius: "5px",
              // padding: "4px",
            }}
          >
            {/* <VehicleTypeList /> */}
          </Box>
        </Grid>
        <Grid
          item
          xs={12}
          md={9}
          sx={{ paddingLeft: "16px !important", paddingTop: "0px !important" }}
        >
          <Container
            maxWidth="lg"
            sx={{
              paddingLeft: "0px !important",
              paddingRight: "0px !important",
              background: "#fff",
            }}
          >
            <Box
              sx={{
                height: { xs: "auto", md: "100vh" },
                // border: "1px solid #d1cfcf",
                // borderRadius: "5px",
                paddingLeft: "0px !important",
                paddingRight: "0px !important",
                // padding: "0px 16px",
                overflow: "scroll",
              }}
            >
              <Box
                sx={{
                  position: "sticky",
                  top: 0,
                  bgcolor: "#fff",
                  zIndex: 1,
                  border: "1px solid #C4CDD5",
                }}
              >
                <PageInfoTitle title="Vehicle Type Details" />
              </Box>
            </Box>
          </Container>
        </Grid>
      </Grid>
    </>
  );
};

export default ClientVehicleType;
